import { Button, Container, Dialog, Grid, IconButton, Paper, Stack, Typography,Box } from '@mui/material';
import { FormProvider, SelectTag, Table, TextField } from '../../../../../components';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { getCurrentDateTime, request, toast } from '../../../../../utils';
import { useEffect, useState } from 'react';
import { BALANCE_REGISTER_REPORT_TYPE, REPORT_TYPE } from '../../../../../constants/dropdown';
import { useLocation } from 'react-router-dom';

const initialSchemeAllotmentDataObj = {
  data: [],
  loading: false
};

export const ProductTrackingReport = () => {
  const { pathname } = useLocation();
  const [openPrint, setOpenPrint] = useState(false);
  const methods = useForm({
    resolver: yupResolver(
      Yup.object().shape({
        from_date: Yup.string().required(' ')
      })
    ),
    defaultValues: {
      from_date: new Date().toISOString().split('T')[0],
      to_date: new Date().toISOString().split('T')[0],
    },
    mode: 'all'
  });

  const { handleSubmit, watch, setValue, reset } = methods;
  const user = JSON.parse(localStorage.getItem('user'));
  console.log("HELLO USERS", user)
  return (
    <>
      <Paper sx={{
        p: 0, flex: 1, borderRadius: 0, boxShadow: 'none',
        width: '100%',
        height: 'auto'
      }}>
        <Container
          sx={{
            mt: 1,
            border: '0px solid',
            borderColor: 'grey.300',
            borderRadius: 1,
            width: '100%',
            maxWidth: 'none',
            minWidth: "100%",
            boxSizing: 'border-box',
          }}
        >
          <FormProvider methods={methods}>
            <Stack
              direction="row"
              spacing={2}
              justifyContent="space-between"
              alignItems="center"
              sx={{
                mb: 1,
                borderBottom: '0px solid',
                borderColor: 'grey.300'
              }}
            >
              <Typography color="primary" variant="h3" sx={{ fontWeight: 600 }}>
              Product Tracking Report
              </Typography>
              <Stack direction="row" justifyContent="flex-end" sx={{ mb: 3 }} spacing={1}>
                <Button
                  variant="contained"
                  disabled={!watch('to_date')}
                  onClick={() =>
                    window.open(
                      `/print${pathname}?refId=${JSON.stringify({ report: watch('report'), from_date: watch('from_date'), to_date: watch('to_date') })}`,
                      '_blank'
                    )
                  }
                >
                  View Report
                </Button>
                <Button variant="contained">Exit</Button>
              </Stack>
            </Stack>
            <Box sx={{ border: '0px solid gray', padding: 2, borderRadius: '8px', width: '60%',boxShadow: '0px 2px 10px #0099ff'  }}>
            <Grid container spacing={2}>
              <Grid item xs={6} sx={{ display: 'flex', gap: 0.3, flexDirection: 'column' }}>
                <Stack spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>From Date</Typography>
                  <TextField sx={{ flex: 0.8 }} name="from_date" type="date" />
                </Stack>
                <Stack spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>To Date</Typography>
                  <TextField sx={{ flex: 0.8 }} name="to_date" type="date" />
                </Stack>
              </Grid>
            </Grid>
            </Box>
          </FormProvider>
        </Container>
      </Paper>
    </>
  );
};
